import React from "react";
import cx from "classnames";
import styles from "./Share.module.scss";
import Divider from "@components/Divider";
import _ from "lodash";
import { useTranslationContext } from "@providers/TranslationProvider";
import { FacebookShareButton, EmailShareButton } from "react-share";
import FacebookShare from "@components/Icons/Share/Facebook";
import EmailShare from "@components/Icons/Share/Email";
import ZaloShare from "@components/Icons/Share/Zalo";
import FacebookShareDark from "@components/Icons/Share/FacebookDark";
import EmailShareDark from "@components/Icons/Share/EmailDark";
import ZaloShareDark from "@components/Icons/Share/ZaloDark";
import { useRouteContext } from "@providers/RouteProvider";
import { usePageContext } from "@providers/PageProvider";
import getter from "@services/StoryArticleService/getter";
import renderPropsComposer from "@utils/renderPropsComposer";
declare var ZaloSocialSDK: any;
const View = ({ light = false }: any) => {
  const { i18n } = useTranslationContext();
  const { article } = usePageContext();
  const { router } = useRouteContext();
  const url = _.get(router, "location.href");
  React.useEffect(() => {
    _.debounce(() => {
      if (typeof ZaloSocialSDK !== undefined) ZaloSocialSDK.reload();
    }, 1000);
  });
  return (
    <section data-scroll-section className={cx("inner", styles.section)}>
      <Divider
        className={styles.divider}
        color={cx({
          "black-1": light,
          "white-1": !light,
        })}
        light={light}
        // opacity="30"
        label={i18n.t("Stories.share")}
      />
      {renderPropsComposer(
        {
          matcher: (light: any) => light,
          render: () => {
            return (
              <div className={styles.group}>
                {/* <div onClick={handler.onShareFB}> */}
                <FacebookShareButton url={url} hashtag="#amanaki">
                  <FacebookShare />
                </FacebookShareButton>
                {/* </div> */}
                <EmailShareButton url={url} subject={getter.title(article)}>
                  <EmailShare />
                </EmailShareButton>
                <div
                  className="cursor-pointer zalo-share-button"
                  data-href=""
                  data-oaid="1723709981556909842"
                  data-layout="1"
                  data-color="blue"
                  data-customize="true"
                >
                  <ZaloShare />
                </div>
              </div>
            );
          },
        },
        {
          matcher: (light: any) => !light,
          render: () => {
            return (
              <div className={styles.group}>
                {/* <div onClick={handler.onShareFB}> */}
                <FacebookShareButton url={url} hashtag="#amanaki">
                  <FacebookShareDark />
                </FacebookShareButton>
                {/* </div> */}
                <EmailShareButton url={url} subject={getter.title(article)}>
                  <EmailShareDark />
                </EmailShareButton>
                <div
                  className="cursor-pointer zalo-share-button"
                  data-href=""
                  data-oaid="1723709981556909842"
                  data-layout="1"
                  data-color="blue"
                  data-customize="true"
                >
                  <ZaloShareDark />
                </div>
              </div>
            );
          },
        }
      )(light)}

      {/* <div className="flex justify-center pb-[5rem]">
        <Button label="explore more" />
      </div> */}
    </section>
  );
};
export default View;
